export const hardBreak = _node => {
  return '\n';
};